import { AthonStoreItem } from '@givebacks/api/store';
import { DonationCreditInfo } from 'core/Components';
import { Stack, Title } from 'ui';

import { AthonDonationTypeButtons } from '../../../donations/components/SimpleDonation/sections/SectionOne/components/AthonDonationTypeButtons';

type AthonPledgeFormProps = {
  isPledge?: boolean;
  isPledgeAvailable: boolean;
  unitsOfActivitySingular?: AthonStoreItem['units_of_activity_singular'];
  onChange?: (value: string | number) => void;
  children?: React.ReactNode;
  credits?: string[];
};

const AthonPledgeForm = ({
  unitsOfActivitySingular,
  credits,
  isPledge,
  isPledgeAvailable,
  onChange,
  children,
}: AthonPledgeFormProps) => {
  return (
    <Stack>
      {isPledgeAvailable ? (
        <AthonDonationTypeButtons
          onChange={onChange}
          isPledge={isPledge}
          unitsOfActivity={unitsOfActivitySingular}
        />
      ) : null}
      <Stack>
        <Stack gap={4}>
          <Title order={4}>{isPledge ? 'Pledge' : 'Donation'} Amount</Title>
          <DonationCreditInfo credits={credits || []} />
        </Stack>
        {children}
      </Stack>
    </Stack>
  );
};

export { AthonPledgeForm };
